// Remove the @use-gesture/react dependency since we can't lazy import the react hooks, instead use @use-gesture/vanilla to dynamically load the library
import { useEffect, useRef } from 'react';

/**
 * A wrapper hook that dynamically loads @use-gesture/vanilla
 */
export function useLazyGesture(ref, handlers, config = {}) {
  const handlersRef = useRef(handlers);
  
  const configRef = useRef(config);

  useEffect(() => {
    handlersRef.current = handlers;
    configRef.current = config;
  });

  useEffect(() => {
    const target = ref.current;
    if (!target) return;

    let gestureInstance = null;
    let mounted = true;

    const init = async () => {
      try {
        const { Gesture } = await import('@use-gesture/vanilla');
        
        if (!mounted || !ref.current) return;
        gestureInstance = new Gesture(ref.current, {
          onDrag: (state) => {
            if (handlersRef.current.onDrag) {
              handlersRef.current.onDrag(state);
            }
          },
          onWheel: (state) => {
            if (handlersRef.current.onWheel) {
              handlersRef.current.onWheel(state);
            }
          },
        }, configRef.current);

      } catch (err) {
        console.error('Failed to load gesture library', err);
      }
    };

    init();

    return () => {
      mounted = false;
      if (gestureInstance) {
        gestureInstance.destroy();
      }
    };
  }, []);
}